module.exports = __webpack_public_path__ + "static/media/leap-gaming.aa01b517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/leap-gaming.jpg
// module id = 2401
// module chunks = 7